module.exports = __webpack_public_path__ + "img/40_69_004_850.f932eab8.jpg";